import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function linkButton(theme: Theme): ComponentStyle {
  return {
    componentName: 'linkButton',
    baseStyle: {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.sizes['-1'],
      padding: `${theme.space['2xs']} ${theme.space.xs}`,
      color: theme.colors.text,
      backgroundColor: theme.colors.onSurface,
      borderRadius: theme.sizes['-4']
    },
    variants: {
      primary: {
        '&:hover': {
          color: theme.colors.link,
          backgroundColor: theme.colors.onSurface200
        }
      },
      secondary: {
        border: `solid 1px ${theme.colors.border15}`,

        '&:hover': {
          color: theme.colors.text,
          backgroundColor: theme.colors.onSurface200
        }
      }
    },
    defaultProps: {
      variant: 'primary'
    }
  };
}
